<template>
    <!-- 弹框资金使用申请 -->
    <div>
        <!-- style="overflow-y: hidden;" -->
        <el-dialog v-dialogDrag title="付款申请" width="85%" :show-close="true" :close-on-click-modal="false" 
        :visible.sync="dialogFormVisible" :before-close="beforeclose">
            <el-button v-if="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true)" size="mini" type="success" plain @click="saveHeader('form')">保存单据</el-button>
            <el-button v-if="form.id" size="mini" type="success" plain @click="sureUpload(form.id)">上传附件</el-button>
            <el-button  size="mini" type="primary" plain @click="refreshHeader()">刷新附件列表</el-button>
            <el-form :model="form" ref="form" :rules="rules" :inline="true" class="demo-form-inline" label-width="110px" size="mini">
                <el-form-item label="单据编号">
                    <el-input :disabled=" true" clearable v-model.trim="bh" autocomplete="off"></el-input>
                    <!-- <el-input :disabled="editCode === true ? false: true" clearable v-model.trim="bh" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item required label="往来单位" prop="company">
                    <el-select v-if="editCode" :disabled=" editCode === true ? false: true" @change="selectCompany" 
                    filterable v-model="form.company" placeholder="请选择往来单位">
                        <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                            :value="{ value: item.id, label: item.name , invoiceInfo: item.invoiceInfo }">
                        </el-option>
                    </el-select>
                    <el-popover v-else placement="bottom" title="tip"  width="300" trigger="hover"
                        content="can't change company, but you can delete this bill and create a new one">
                        <el-input slot="reference" disabled v-model="form.company"></el-input>
                    </el-popover>
                    <!-- <el-select :disabled="((form.checkStatus === 0 || form.checkStatus === 3 || editCode === true) && (detailData.length === 0)) ? false: true" @change="selectCompany"  -->
                    
                    <!-- <el-input v-model.trim="form.company" autocomplete="off"></el-input> -->
                </el-form-item>
                <!-- <el-form-item label="金额" prop="amount">
                    <el-input :disabled="editCode === true ? false: true" clearable v-model.number="form.amount" autocomplete="off"></el-input>
                </el-form-item> -->
                <el-form-item required label="发票情况" prop="invoiceType">
                    <el-select :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true ) ? false: true" 
                    filterable v-model="form.invoiceType" placeholder="请选择业务类型">
                        <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发票号" :prop=" form.invoiceType === '有发票' ? 'voucherNo' : ''">
                    <el-input clearable :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true) ? false: true" 
                    v-model="form.voucherNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item required label="币制" prop="currency">
                    <el-select :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true) ? false: true" 
                    filterable v-model="form.currency" placeholder="请选择币制">
                        <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model.trim="form.currency" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-row >
                    <el-col span="12">
                        <el-form-item label="备注" prop="note" style="width: 100%" class="item_width_100">
                            <el-input style="width: 100% !important;" type="textarea" :rows="2" :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true)? false: true" 
                            clearable v-model="form.note" autocomplete="off"  ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col span="12">
                        <el-form-item label="开票信息" prop="invoiceInfo" style="width: 100%" class="item_width_100">
                            <el-input type="textarea" :rows="2" :disabled="(form.checkStatus === 0 || form.checkStatus === 3 || editCode === true)? false: true" 
                            clearable v-model="form.invoiceInfo" autocomplete="off" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-form-item required label="银行账号" prop="bank">
                    <el-select :disabled="(form.checkStatus === 0 || form.checkStatus === 3  || editCode === true)? false: true" filterable v-model.trim="form.bank" placeholder="请选择银行帐号" @change="selectBank">
                        <el-option v-for="item in bankOption" :key="item.id" :label="item.bankName"
                            :value="{ value: item.accountNum, label: item.bankName }">
                            <span style="float: left">{{ item.bankName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.accountNum }}</span>
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="上传供应商账单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveGYS" :on-change="handleChangeGYS"
                            multiple :file-list="fileListGYS" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传发票">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveFP" :on-change="handleChangeFP"
                            multiple :file-list="fileListFP" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传报关单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveBGD" :on-change="handleChangeBGD"
                            multiple :file-list="fileListBGD" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传其他">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveQT" :on-change="handleChangeQT"
                            multiple :file-list="fileListQT" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-form-item label="上传附件">
                    <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemove" :on-change="handleChange"
                    multiple :file-list="fileList" :auto-upload="false">
                    <el-button size="mini" type="primary" >点击选择文件</el-button>
                    </el-upload>
                </el-form-item> -->
                <!-- <el-form-item label="附件列表" v-if="uploadFilesList.length>0">
                    <div class="upload-list">
                        <span v-for="item in uploadFilesList" :key="item.id">
                            <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }}</el-link>
                        </span>
                    </div>
                </el-form-item> -->
            </el-form>
            <div class="upload_box">
                <div class="upload_text">附件列表</div>
                <div class="upload-list"  v-if="uploadFilesList.length>0">
                    <span v-for="item in uploadFilesList" :key="item.id">
                        <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.annexName }} ({{item.annexType}})</el-link>
                    </span>
                </div>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
                <!-- <el-button >取 消</el-button>
                <el-button type="primary" >确 定</el-button> -->
            <!-- </div>  -->
            <!-- 明细表格展示 -->
            <div>
                <el-button v-if="((form.checkStatus === 0  || form.checkStatus === 3 || editCode === true)&& !sealedBoxShow)"
                 plain size="mini" icon="el-icon-delete" type="danger" @click="deleteRowDetail">批量删除</el-button>
                <el-table height="260px" :data="detailData" show-summary :summary-method="getSummaries" size="mini"
                    border ref="detailData" style="width: 100%;font-size: calc(15vw * 100 / 1920);margin-top: 5px; "
                     @selection-change="selectionChange">
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column prop="blNo" label="提单号" align="center"> </el-table-column>
                    <el-table-column prop="subNo" label="分单号" align="center"> </el-table-column>
                    <el-table-column prop="containerNo" label="箱号" align="center">
                    </el-table-column>
                    <el-table-column prop="feeName" label="费用名称" align="center">
                    </el-table-column>
                    <el-table-column prop="amount" label="结算金额" align="center">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createMan" label="创建人" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="note" label="备注" align="center">
                        <template slot-scope="scope">
                            <div class="ellipsis" @click="viewNote(scope.row.note)">{{ scope.row.note }}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="auto" align="center" v-if="((form.checkStatus === 0  || form.checkStatus === 3 || editCode === true)&& !sealedBoxShow)">
                        <template slot-scope="scope">
                            <el-button plain size="mini" icon="el-icon-delete" type="danger"
                                @click="deleteRowDetail(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
            <el-divider content-position="center" >查询费用</el-divider>
            <!-- 查询并修改明细 -->
            <div v-if="((form.checkStatus === 0 || form.checkStatus === 3 || editCode === true) && !sealedBoxShow)">
                <el-form :model="expenditList" ref="expenditList" size="mini"
                    style=" margin-top: 3px; display: flex; justify-content: space-around;" label-width="90px">
                    <div>
                        <el-form-item label="开始时间" prop="startDate">
                            <el-date-picker style="width: 100%;" clearable size="small" v-model="expenditList.startDate"
                                type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"
                                :picker-options="startNoTime">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endDate">
                            <el-date-picker style="width: 100%;" clearable size="small" v-model="expenditList.endDate"
                                type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间"
                                :picker-options="endNoTime">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="提单号" prop="blNo">
                            <el-input type="textarea" clearable v-model="expenditList.blNo" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="费用名称" prop="feeName">
                            <el-select filterable clearable v-model="expenditList.feeName" placeholder="请选择费用名称">
                                <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                    :value="item.feeName">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>
                    <div>
                        <el-form-item label="往来单位" prop="custName">
                            <el-input disabled v-model="expenditList.custName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="币制" prop="currency">
                            <el-input disabled clearable v-model="expenditList.currency"
                                autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-button  type="primary" size="mini"
                            @click="expendRow">查询应付明细</el-button>
                        <el-button size="mini" @click="allSaveList" type="success" style="">添加明细</el-button>
                    </div>

                </el-form>
                <div>
                    <!-- <el-button size="small" @click="addRow">编辑全部</el-button> -->
                    <el-table height="30vh" @selection-change="handleSelectionChange"
                        :data="detailtableData" :empty-text="'暂无数据'" size="mini" highlight-current-row
                        style="width: 100%; font-size: calc(15vw * 100 / 1920); margin-top: -0.6vh;">
                        <el-table-column type="selection" width="35" align="center"> </el-table-column>
                        <el-table-column prop="blNo" label="提单号" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input clearable disabled v-model="scope.row.blNo" placeholder="请输入提单号"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.blNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="subNo" label="分单号" width="auto" align="center"> </el-table-column>
                        <el-table-column prop="containerNo" label="箱号" width="auto" align="center"> </el-table-column>
                        <el-table-column prop="company" label="客户名称" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.company" placeholder="请输入客户名称"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.company }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="feeName" label="费用名称" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-select disabled filterable clearable v-model="scope.row.feeName"
                                    placeholder="请选择费用名称" v-show="scope.row.editing">
                                    <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                        :value="item.feeName">
                                    </el-option>
                                </el-select>
                                <span v-show="!scope.row.editing">{{ scope.row.feeName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remain" label="结算金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <!-- <el-input @input="limitInput(scope.row)" style="width: 100%;"
                                    onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable v-model="scope.row.remain"
                                    placeholder="请输入应付" v-format="'#,##0.00'"></el-input> -->
                                    <el-input @input="limitInput(scope.row)" style="width: 100%;"
                                    onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable v-model="scope.row.remain"
                                    placeholder="请输入应付"></el-input>
                                <!-- <span>{{ scope.row.remainCopy }}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column prop="finance" label="已付金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model.number="scope.row.finance" placeholder="请输入余额"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.finance }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalWt" label="应付总金额" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.totalWt" placeholder="请输入总金额"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing" v-format="'#,##0.00'">{{ scope.row.totalWt }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="currency" label="币制" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.currency" placeholder="请输入币制"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.currency }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input disabled clearable v-model="scope.row.createTime" placeholder="请输入创建时间"
                                    v-if="scope.row.editing"></el-input>
                                <span v-show="!scope.row.editing">{{ scope.row.createTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="note" label="备注" width="auto" align="center">
                            <template slot-scope="scope">
                                <el-input style="width: 100%;" clearable v-model="scope.row.note"
                                    placeholder="请输入备注"></el-input>
                                <!-- <span v-show="!scope.row.editing">{{ scope.row.note }}</span> -->
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <!-- <el-button v-if="!scope.row.editing" @click="startEditing(scope.row)" type="text"
                                    size="small">
                                    编辑
                                </el-button> -->
                                <!-- 保存 -->
                                <!-- <el-button v-else @click="save(scope.row)" type="text" size="small">
                                    取消编辑
                                </el-button> -->
                                <el-button v-if="!scope.row.editing" @click="deleteRow(scope.row)" type="text"
                                    size="mini" style="margin-left: 10px;padding: 3px;">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'addFund',
    props: ['busId',],
    data() {
        return {
            editCode:false,// 添加时除发票号外都可填写
            isbig: false,
            remain: '',//结算金额显示余额
            headerId: '',//表头id
            detailSelect: [],//应付费用明细列表数据
            detailtableData: [],//应付费用明细列表
            expenditList: {
                feeName: '',
                blNo: '',
                blNos:[],
                custName: '',
                currency: '',
                startDate: '',
                endDate: '',
                feeType: 2
            },//应付费用明细列表查询
            detailData: [],//应付明细数据
            feeOption: [],//费用类型数据
            bankOption: [],
            typeOption: [],
            customOption: [],
            originalBankOption: [], // 用于存储初始的 bankOption，以便对比
            invoiceTypeList:[ // 业务发票类型
                { value: '有发票', label: '有发票' },
                { value: '无发票', label: '无发票' },
                { value: '后来发票', label: '后来发票' },
            ], 
            dialogFormVisible: false,
            form: {
                // amount:'',
                company: '',
                voucherNo: '',
                // bank: '',
                // bankAccount: '',
                note: '',//备注
                currency: '',
                id: '',
                checkStatus:Number(),
                invoiceInfo:'',
                invoiceType:'',
            },
            companyId: '',
            bh: '',
            sealedBoxShow:false,// 检查是否是封箱费
            uploadFilesList: [], // 已上传文件列表
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
            fileList:[], // 上传文件列表
            multipleSelection:[], // 表格选中数据
            fileListGYS:[],
            fileListFP:[],
            fileListQT:[],
            fileListBGD:[],
            rules: {
                company: [
                    { required: true, message: '请选择往来单位', trigger: 'change' }
                ],
                voucherNo: [
                    { required: true, message: '请填写发票号', trigger: 'blur' }
                ],
                // bank: [
                //     { required: true, message: '请选择银行帐户', trigger: 'change' }
                // ],
                // bankAccount: [
                //     { required: true, message: '请选择活动资源', trigger: 'change' }
                // ],
                // amount: [
                //     { required: true, message: '请填写金额', trigger: 'blur' }
                // ],
                invoiceType:[
                    { required: true, message: '请选择业务类型', trigger: 'change' }
                ],
                invoiceInfo:[
                    { required: true, message: '请填写开票信息', trigger: 'blur' }
                ],
                currency: [
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
            },
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
        }
    },
    updated() {
        //异步更新表格内数据
        this.$nextTick(() => {
            if (this.$refs.detailData) {
                this.$refs.detailData.doLayout();
            }
        });


    },
    watch: {
        "expenditList.startDate": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "expenditList.endDate": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        'form.company': function (newValue, oldValue) {
            // 往来单位发生变化时检查币制是否也有值，如果都有值则调用接口
            // if (newValue && this.form.currency) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                // if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                // }

            // }
        },
        'form.currency': function (newValue, oldValue) {
            // 币制发生变化时检查往来单位是否也有值，如果都有值则调用接口
            // if (newValue && this.form.company) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                // if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                // }

            // }
        },
    },
    computed: {
    },

    mounted() {
        //数据渲染完毕后再监听

        // this.$watch('form.amount', {
        //     handler(newVal, oldVal) {
        //         if (!this.isInitialLoad) {
        //         this.saveHeader(1);

        //     },
        //     deep: true,
        //     immediate: false
        // });

    },
    created() {
        this.getcustomList();
        this.getTypeOption();
        this.getFeeList();
        // this.expendRow();
        // this.getFundDetail();
    },
    methods: {
        // 刷新附件
        refreshHeader(){
            this.uploadFiles(this.headerId)
        },
        // 文件预览
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName,
                    id: data.id
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        handleSelectionChange(val) {
            this.detailSelect = val;
        },
        // saveamount(){
        //     this.saveHeader(1);
        // },
        limitInput(row) {
            if (parseFloat(row.remain) > row.remainCopy) {
                this.$message.warning('输入值不能高于余额');
                row.remain = row.remainCopy;
                this.isbig = true;

            } else {
                this.isbig = false;
            }

        },
        // 合计行
        //指定列求和
        // 合计金额
        // 合计行 方法
        getSummaries(param) {
            const { columns = [], data = [] } = param
            if( data.length > 0 ){
                const sums = []
                const sumColArr = ['结算金额']
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计'
                        return
                    }
                    // 这里添加需要进行合计的列的名称
                    if (sumColArr.includes(column.label)) {
                        const values = data .map(item => Number(item[column.property] || 0)) .filter(value => !isNaN(value));
                        if (values.length > 0) {
                            const sum = values.reduce((prev, curr) => prev + curr, 0);
                            sums[index] = parseFloat(sum.toFixed(2));
                        } else {
                            sums[index] = ' ';
                        }
                    } else {
                        sums[index] = ' ';
                    }
            })

            // this.form.amount = sums[3];
            return sums
            }

        },

        rowStyle() {
            return "text-align:center";
        },
        // 判断选择的费用信息是否是本人创建
        checkCreatValues(array, value) {
            return array.every(item => item.createMan === value);
        },
        //删除明细
        deleteRowDetail() {
            // 判断是否选中数据
            if (!this.multipleSelection.length) {
                this.$message({
                    type: 'error',
                    message: '请选择要删除的数据!'
                })
                return;
            }
            const value = localStorage.getItem('name');
            // 判断是否是本人创建
            if(!this.checkCreatValues(this.multipleSelection, value)){
                this.$message({
                    type: 'error',
                    message: '非本人创建，无法删除!'
                })
                return
            }
            let URL = `${url1.removeDetailsByIds}`;
            // 添加需要删除的id
            let obj = this.multipleSelection.map(item => item.id); 
            req.post(URL, obj).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDetailexList(this.form.id)
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 获取明细
        getDetailexList(feeId) {
            let URL = `${url1.getVoucherList}/${feeId}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.detailData = res.data.data.data;
                }
            })
        },
        // 获取应付信息
        expendRow() {
            this.expenditList.custName = this.form.company;
            this.expenditList.currency = this.form.currency;
            // 将提单号转化为数组
            if(this.expenditList.blNo){
                this.expenditList.blNos = this.expenditList.blNo.split('\n');

            }else{
                this.expenditList.blNos = [];
            }
            let URL = `${url1.getFeeByConditon}/`;
            req.post(URL, this.expenditList).then(res => {
                if (res.data.code === 200) {
                    this.detailtableData = res.data.data;
                    this.detailtableData.forEach(row => {
                        this.$set(row, 'editing', false);
                        // row.finance = row.remain;
                        row.remainCopy = row.remain;
                        row.note = '';
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        addRow() {
            this.detailtableData.forEach(row => {
                // row.editing = false;
                this.$set(row, 'editing', true);
            });

        },
        deleteRow(row) {
            // 删除行的逻辑
            const index = this.detailtableData.indexOf(row);
            if (index !== -1) {
                this.detailtableData.splice(index, 1);
                // if (row.id) {
                //     let URL = `${url.deleteContainer}/${row.id}`;
                //     req.delete(URL).then(res => {
                //         if (res.data.code === 200) {
                //             this.$message({
                //                 type: 'success',
                //                 message: '删除成功'
                //             })
                //             this.amendRow();
                //         } else {
                //             this.$message({
                //                 type: 'error',
                //                 message: res.data.message
                //             })
                //         }
                //     })
                // }

            }
        },
        startEditing(row) {
            this.$set(row, 'editing', true);
        },
        // 确定保存
        allSaveList() {
            if (this.detailSelect.length == 0) {
                this.$message.warning('请选择内容！');
            } else {
                let hasEmptyValue = false;
                this.detailSelect.forEach(row => {
                    if (!row.remain) {
                        hasEmptyValue = true;
                        return false; // 提前退出循环
                    }
                });
                if (hasEmptyValue) {
                    this.$message.warning('请填写完整空白内容');
                } else {
                    let flag = false;
                    this.detailSelect.forEach(row => {
                        if (row.editing == true) {
                            this.$set(row, 'editing', false);
                        }

                    })
                    if (flag) {
                        this.$message({
                            type: 'warning',
                            message: '请先保存全部！'
                        })
                    } else {
                        let URL = `${url1.pushVoucherDetail}`;
                        let obj = [];
                        //如果是编辑  else新增
                        obj = this.detailSelect.map(item => {
                            return {
                                voucherId: this.form.id,
                                feeId: item.id,
                                amount: item.remain,
                                note: item.note,
                                containerNo:item.containerNo,
                                currency:item.currency,
                                blNo:item.blNo,
                                subNo:item.subNo,
                            };
                        });
                        let shouldContinue = true;
                        for (const item of this.detailSelect) {

                            if (item.remain <= 0) {
                                this.$message({
                                    type: 'error',

                                    message: '应付额度不能小于等于0!'
                                });
                                shouldContinue = false;
                                break;
                            } else {
                                this.$nextTick(() => {
                                    obj.map(item => {
                                        this.getDetailexList(item.voucherId);
                                    });
                                })

                                shouldContinue = true;
                                break;
                            }
                        }

                        if (shouldContinue) {
                            req.post(URL, obj).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '更改成功'
                                    });
                                    this.$nextTick(() => {
                                        obj.map(item => {
                                            this.getDetailexList(item.voucherId);
                                        });
                                        this.detailSelect = [];
                                        this.expendRow();
                                    })

                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    });
                                }
                            });
                        }
                    }


                    // this.detailtableData.map(item => {
                    //     if (this.isbig) {
                    //         this.$message({
                    //             type: 'error',
                    //             message: '应付金额不能大于余额！'
                    //         })

                    //     } else if (item.remain <= 0) {
                    //         this.$message({
                    //             type: 'error',
                    //             message: '应付额度不能小于等于0!'
                    //         })
                    //     } else {
                    //         obj.map(item => {
                    //             this.getDetailexList(item.voucherId)
                    //         })
                    //     }
                    // })
                    // req.post(URL, obj).then(res => {
                    //     if (res.data.code === 200) {
                    //         this.$message({
                    //             type: 'success',
                    //             message: '更改成功'
                    //         })
                    //         // this.expendRow();                                  
                    //         obj.map(item => {
                    //             this.getDetailexList(item.voucherId)
                    //         })
                    //         this.detailtableData = [];
                    //     } else {
                    //         this.$message({
                    //             type: 'error',
                    //             message: res.data.message
                    //         })
                    //     }
                    // })
                }
            }
        },
        save(row) {
            this.$set(row, 'editing', false);
        },
        saveAll() {
            this.detailtableData.forEach(row => {
                // row.editing = false;
                this.$set(row, 'editing', false);
            });
        },
        //费用名称
        getFeeList() {
            let URL = `${url.fee}?feeName=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeOption = res.data.data;
                }
            })
        },
        // 初始化表头
        getFundDetail(row) {
            const  localRow = JSON.parse(JSON.stringify(row));
            if( localRow === 0){
                this.editCode = true
                this.form = {
                    checkStatus:0,
                    company: '',
                    voucherNo: '',
                    invoiceType:'',
                    // bank: '',
                    // bankAccount: '',
                    note: '',//备注
                    // amount: '',
                    currency: '',
                    id: '',
                }
            }else{
                let URL = `${url1.getVoucherHeadById}/${this.busId}`;
                req.get(URL).then(res => {
                    // this.$nextTick(() => { 
                    this.form =  res.data.data
                    // })
                    this.headerId = res.data.data.id;
                    this.getDetailexList(this.headerId)
                    // let bank = this.form.bank;
                    // this.form.bank = `${this.form.bankAccount}-${bank}`;
                    for (let item of this.customOption) {
                        if (item.name === this.form.company) {
                            this.companyId = item.id;
                        }
                    }
                    this.bh = this.form.billNo;
                    // 判断是否是封箱费
                    this.sealedBoxShow = this.bh.startsWith('YX')
                    this.expenditList.custName = this.form.company;
                    this.expenditList.currency = this.form.currency;
                    // 查询是否存在上传附件
                    this.uploadFiles(this.headerId)
                    // this.fetchBankAccounts();
                })
            }
        },
        // 查询上传附件
        uploadFiles(id){
            // getFileListByVoucherId
            let URL = `${url1.getFileListByVoucherId}/${id}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.uploadFilesList = res.data.data
                }
            })
        },
        beforeclose() {
            this.multipleSelection = []
            this.expenditList = {
                feeName: '',
                blNo: '',
                custName: '',
                currency: '',
                startDate: '',
                endDate: '',
                feeType: 2
            },
            this.detailData = [];
            this.detailtableData = [];
            this.form.allBank = '';
            this.form.id = '';
            this.form.company = '';
            this.form.voucherNo = '';
            // this.form.bank = '';
            // this.form.bankAccount = '';
            this.form.note = '';
            // this.form.amount = '';
            this.form.currency = '';
            this.bh = '';
            this.headerId = '';
            // this.$refs.form.resetFields()
            this.dialogFormVisible = false;
            this.editCode = false;
            // this.bankOption = [];
            this.uploadFilesList = []
            // this.$parent.submit();
        },
        selectCompany(data) {
            const { value, label, invoiceInfo } = data;
            // 对formValue中的银行code和银行名称重新赋值
            this.form.company = label;
            this.companyId = value;
            this.form.invoiceInfo =  invoiceInfo;
        },
        // selectBank(data) {        
        //     const { value, label } = data;
        //     // 对formValue中的银行code和银行名称重新赋值
        //     // this.form.bank = value;
        //     this.form.bankAccount = label;
        //     this.form.bank = `${label}-${value}`;
        // },

        saveHeader(form) {
            // if (form === 1) {
            //     if (this.form.currency === '' || this.form.company === '' || this.form.voucherNo === '') {
            //         // this.$message({
            //         //     type: 'error',
            //         //     message: '请填写必填项'
            //         // });
            //         return;
            //     } else {
            //         let URL = `${url1.saveOrUpdateVoucherBase}`;
            //         // let bank = this.form.bank.split('-')[0];
            //         // this.form.bank = bank;
            //         this.form.flag = 'FK';
            //         if (!this.form.id) {
            //             let newForm = { ...this.form };
            //             // 删除新对象中的amount属性
            //             delete newForm.amount;
            //             req.post(URL, newForm).then(res => {
            //                 if (res.data.code === 200) {
            //                     this.$message({
            //                         type: 'success',
            //                         message: res.data.message
            //                     })
            //                     let option = res.data.data;
            //                     this.form.id = option.split("|")[0];
            //                     this.getDetailexList(option.split("|")[0])
            //                     this.bh = option.split("|")[1];
            //                 } else {
            //                     this.$message({
            //                         type: 'error',
            //                         message: res.data.message
            //                     })
            //                 }
            //             })
            //         } else {
            //             this.form.flag = 'FK';
            //             let newForm = { ...this.form };

            //             // 删除新对象中的amount属性
            //             delete newForm.amount;
            //             req.post(URL, newForm).then(res => {
            //                 if (res.data.code === 200) {
            //                     // this.$message({
            //                     //     type: 'success',
            //                     //     message: res.data.message
            //                     // })
            //                 } else {
            //                     this.$message({
            //                         type: 'error',
            //                         message: res.data.message
            //                     })
            //                 }
            //             })
            //         }
            //     }
            // } else {
                this.$refs[form].validate((valid) => {
                    if (valid) {        
                        let URL = `${url1.saveOrUpdateVoucherBase}`;
                        // let bank = this.form.bank.split('-')[0];
                        // this.form.bank = bank;
                        this.form.flag = 'FK';
                        if (!this.form.id) {
                            let newForm = { ...this.form };
                            // 删除新对象中的amount属性
                            // delete newForm.amount;
                            req.post(URL, newForm).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    let option = res.data.data;
                                    this.form.id = option.split("|")[0];
                                    this.getDetailexList(option.split("|")[0])
                                    this.bh = option.split("|")[1];
                                    // 保存文件
                                    this.sureUpload(option.split('|')[0])
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        } else {
                            this.form.flag = 'FK';
                            let newForm = { ...this.form };
                            // 删除新对象中的amount属性
                            // delete newForm.amount;
                            req.post(URL, newForm).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.message
                                    })
                                    // 保存文件
                                    this.sureUpload(this.form.id)
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: '请填写必填项'
                        });
                    }
                });
            // }
        },
        // 确认上传文件
        async sureUpload(voucherId){
            // 调用删除费用信息接口
                 try {
                    // 创建Promise数组
                    // 供应商
                    if (this.fileListGYS.length > 0) {
                        const promisesGYS = this.fileListGYS.map(item => {
                            const formDataGYS = new FormData();
                            formDataGYS.append('file', item.raw);
                            formDataGYS.append('businessId', this.businessId);
                            formDataGYS.append('voucherId', voucherId);
                            formDataGYS.append('annexType', '供应商账单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataGYS);
                        });
                        await Promise.all(promisesGYS);
                    }
                    // 发票
                    if (this.fileListFP.length > 0) {
                        const promisesFP = this.fileListFP.map(item => {
                            const formDataFP = new FormData();
                            formDataFP.append('file', item.raw);
                            formDataFP.append('businessId', this.businessId);
                            formDataFP.append('voucherId', voucherId);
                            formDataFP.append('annexType', '发票');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataFP);
                        });
                        await Promise.all(promisesFP);
                    }
                    // 报关单
                    if (this.fileListBGD.length > 0) {
                        const promisesBGD = this.fileListBGD.map(item => {
                            const formDataBGD = new FormData();
                            formDataBGD.append('file', item.raw);
                            formDataBGD.append('businessId', this.businessId);
                            formDataBGD.append('voucherId', voucherId);
                            formDataBGD.append('annexType', '报关单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataBGD);
                        });
                        await Promise.all(promisesBGD);
                    }
                     // 其他
                    if (this.fileListQT.length > 0) {
                        const promisesQT = this.fileListQT.map(item => {
                            const formDataQT = new FormData();
                            formDataQT.append('file', item.raw);
                            formDataQT.append('businessId', this.businessId);
                            formDataQT.append('voucherId', voucherId);
                            formDataQT.append('annexType', '其他');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataQT);
                        });
                        await Promise.all(promisesQT);
                    }
                    // 完成后操作
                    this.fileListGYS = [];
                    this.fileListFP = [];
                    this.fileListBGD = [];
                    this.fileListQT = [];
                    this.uploadFiles(this.form.id)
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message);
                }
        },
        //    调用上传文件接口
        saveOneAttachment(fileUrl,formData){
            return req.post(fileUrl,formData).then(res => {
                if (res.data.code === 200) {
                    return res.data
                }else{
                    throw new Error(res.data.message || '上传失败');
                }
            })
        },
        //获取银行账号密码
        // fetchBankAccounts() {
        //     let URL = `${url1.getBankInfo}/${this.companyId}/${this.form.currency}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.bankOption = res.data.data;
        //             // this.form.bank = res.data.data.bank;
        //             // this.form.bankAccount = res.data.data.bankAccount;
        //         }
        //     })
        // },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        // 文件上传时勾子
        handleChangeGYS(file, fileList){
            this.fileListGYS = fileList;
        },
        handleChangeFP(file, fileList){
            this.fileListFP = fileList.filter(item => item.name.includes('发票'))
            // 如果有不符合条件的文件，给出提示
            const invalidFiles = fileList.filter(item => !item.name.includes('发票'))
            if (invalidFiles.length > 0) {
                this.$message.warning(`有 ${invalidFiles.length} 个文件因名称不含"发票"已被过滤`)
            }
        },
        handleChangeBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        handleChangeQT(file, fileList){
            this.fileListQT = fileList;
        },
        // 移除文件勾子
        handleRemoveGYS(file, fileList){
            this.fileListGYS = fileList;
        },
        handleRemoveBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        handleRemoveQT(file, fileList){
            this.fileListQT = fileList;
        },
        handleRemoveFP(file, fileList){
            this.fileListFP = fileList;
        },
        // 表格选中数据
        selectionChange(val){
            this.multipleSelection = val
        },
        // 点击查看全部备注
        viewNote(note){
            this.$confirm(note, '提示', {
                confirmButtonText: '确定',
            }).then(() => {
                }).catch(() => {       
            });
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep body,
html {
    overflow-y: hidden;
}
.upload_box{
    display: flex;
}
.upload_text{
    text-align: right;
    width: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.upload-list{
    min-width: 600px;
    display: flex;
}
.list-margin{
    margin: 0px 5px;
}
::v-deep .el-input__inner {
    height: 1.9em;
}
.el-form-item {
    margin-bottom: 0.6vh;
}


::v-deep .el-table .el-table__cell {
    padding: 1.1px 0;
}

::v-deep .el-dialog.is-fullscreen {
    background-color: #F8F8F5;
}
::v-deep .el-dialog {
    margin: 10px auto !important;
}
.el-form-item__error {
    padding-top: 0;
}
.el-select {
    width: 100%;
}
::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #f4f5f7;
    color: #030303;
}
::v-deep  .el-dialog__body {
    padding: 0px 10px !important;
}
::v-deep  .el-form-item__content {
    width: 280px !important;
}
::v-deep .el-divider__text {
    color: #959595 ;
}
/* ::v-deep .upload-demo{
    display: flex;
} */
/* ::v-deep .el-upload-list {
    display: flex;
} */
/* ::v-deep .el-upload-list__item:first-child {
    margin-top: 5px;
    margin-left: 10px;
} */
::v-deep .el-dialog__header {
    padding: 10px;
}
.ellipsis{
    display: -webkit-box;
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;
    overflow: hidden
}
::v-deep .item_width_100 .el-form-item__content{
    width: calc(100% - 110px)!important;
}
</style>